import axios from "axios";
import { toast } from "react-toastify";
import { push } from "connected-react-router";

export const BUSINESS_GET_ARTICLES_REQUEST = "BUSINESS_GET_USERS_REQUEST";
export const BUSINESS_GET_ARTICLES_SUCCESS = "BUSINESS_GET_ARTICLES_SUCCESS";
export const BUSINESS_GET_ARTICLES_FAIL = "BUSINESS_GET_ARTICLES_FAIL";
export const getArticles = params => dispatch => {
  dispatch({
    type: BUSINESS_GET_ARTICLES_REQUEST
  });
  axios
    .request({
      url: "business_ggs",
      params: params,
      method: "GET"
    })
    .then(({ data }) => {
      if (data.success) {
        dispatch({
          type: BUSINESS_GET_ARTICLES_SUCCESS,
          msg: data.message,
          data: data.data
        });
      } else {
        dispatch({
          type: BUSINESS_GET_ARTICLES_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        // toast.warn(data.message);
      }
    });
};

export const BUSINESS_REMOVE_ARTICLE_REQUEST =
  "BUSINESS_REMOVE_ARTICLE_REQUEST";
export const BUSINESS_REMOVE_ARTICLE_SUCCESS =
  "BUSINESS_REMOVE_ARTICLE_SUCCESS";
export const BUSINESS_REMOVE_ARTICLE_FAIL = "BUSINESS_REMOVE_ARTICLE_FAIL";
export const removeArticle = post_id => dispatch => {
  dispatch({
    type: BUSINESS_REMOVE_ARTICLE_REQUEST
  });
  axios
    .request({
      url: "dashboard/business_gg/remove",
      data: {
        business_ad_id: post_id
      },
      method: "post"
    })
    .then(({ data }) => {
      if (data.success) {
        dispatch({
          type: BUSINESS_REMOVE_ARTICLE_SUCCESS
        });
        toast.success(data.message);
        dispatch(push("/dash/admin/business-advertisements"));
      } else {
        dispatch({
          type: BUSINESS_REMOVE_ARTICLE_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        // toast.warn(data.message);
      }
    });
};

export const BUSINESS_GET_ARTICLE_REQUEST = "BUSINESS_GET_ARTICLE_REQUEST";
export const BUSINESS_GET_ARTICLE_SUCCESS = "BUSINESS_GET_ARTICLE_SUCCESS";
export const BUSINESS_GET_ARTICLE_FAIL = "BUSINESS_GET_ARTICLE_FAIL";
export const getArticle = id => dispatch => {
  dispatch({
    type: BUSINESS_GET_ARTICLE_REQUEST
  });
  axios
    .request({
      url: "business_gg",
      params: {
        business_ad_id: id
      },
      method: "GET"
    })
    .then(({ data }) => {
      if (data.success) {
        dispatch({
          type: BUSINESS_GET_ARTICLE_SUCCESS,
          msg: data.message,
          data: data.data
        });
      } else {
        dispatch({
          type: BUSINESS_GET_ARTICLE_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        // toast.warn(data.message);
      }
    });
};

export const BUSINESS_EDIT_ARTICLE_REQUEST = "BUSINESS_EDIT_ARTICLE_REQUEST";
export const BUSINESS_EDIT_ARTICLE_SUCCESS = "BUSINESS_EDIT_ARTICLE_SUCCESS";
export const BUSINESS_EDIT_ARTICLE_FAIL = "BUSINESS_EDIT_ARTICLE_FAIL";
export const editArticle = ({
  business_ad_id,
  position,
  title,
  cover_img,
  contact,
  email,
  phone,
  website,
  area
}) => dispatch => {
  let params = new FormData(); //如果需要上传多张图片,需要遍历数组,把图片的路径数组放入formData中
  params.append("business_ad_id", business_ad_id);
  if (position) params.append("position", position);
  if (title) params.append("title", title);
  if (contact) params.append("contact", contact);
  if (cover_img) params.append("cover_image", cover_img);
  if (email) params.append("email", email);
  if (website) params.append("website", website);
  if (phone) params.append("phone", phone);
  if (area) params.append("area", area);
  dispatch({
    type: BUSINESS_EDIT_ARTICLE_REQUEST
  });
  axios
    .request({
      url: "dashboard/business_gg/edit",
      data: params,
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
    .then(({ data }) => {
      if (data.success) {
        dispatch({
          type: BUSINESS_EDIT_ARTICLE_SUCCESS,
          msg: data.message,
          data: data.data
        });
        dispatch(push("/dash/admin/business-advertisements"));
      } else {
        dispatch({
          type: BUSINESS_EDIT_ARTICLE_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        toast.warn(data.message);
      }
    });
};

export const BUSINESS_CREATE_ARTICLE_REQUEST =
  "BUSINESS_CREATE_ARTICLE_REQUEST";
export const BUSINESS_CREATE_ARTICLE_SUCCESS =
  "BUSINESS_CREATE_ARTICLE_SUCCESS";
export const BUSINESS_CREATE_ARTICLE_FAIL = "BUSINESS_CREATE_ARTICLE_FAIL";
export const createArticle = ({
  position,
  title,
  cover_img,
  contact,
  email,
  phone,
  website,
  area
}) => dispatch => {
  let params = new FormData(); //如果需要上传多张图片,需要遍历数组,把图片的路径数组放入formData中
  params.append("position", position);
  params.append("title", title);
  params.append("contact", contact);
  if (cover_img) params.append("cover_image", cover_img);
  if (email) params.append("email", email);
  if (website) params.append("website", website);
  params.append("phone", phone);
  if (area) params.append("area", area);
  dispatch({
    type: BUSINESS_CREATE_ARTICLE_REQUEST
  });
  axios
    .request({
      url: "dashboard/business_gg/create",
      data: params,
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
    .then(({ data }) => {
      if (data.success) {
        dispatch({
          type: BUSINESS_CREATE_ARTICLE_SUCCESS,
          msg: data.message,
          data: data.data
        });
        dispatch(push("/dash/admin/business-advertisements"));
      } else {
        dispatch({
          type: BUSINESS_CREATE_ARTICLE_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });

        toast.warn(data.message);
      }
    });
};
